import { instanteDaDataDoBackend } from '@modules/aawz-intelligence-v2/utils/data-do-backend'

/**
 * Ordem de "Recentes" — a da lista do ChatGPT: quem recebeu mensagem por
 * último fica no topo.
 *
 * Existe porque o servidor lista por `created_at` (`resource_conversations.py`,
 * `sort_by=['created_at']`) e a linha mostra `updated_at`: uma conversa antiga
 * que acaba de receber mensagem chegava no FIM com "agora" (print do usuário,
 * 14/09/2026). Ponto ÚNICO de ordenação, consumido pelos getters da store —
 * lateral, popup, palette e `aiFramework` leem dali.
 *
 * Puro: devolve cópia, nunca muda a lista recebida.
 */

/**
 * Instante de recência de uma conversa: `updated_at` (a última mensagem), com
 * `created_at` de reserva. `null` sem data legível — aceita os dois formatos
 * que circulam (`DD/MM/YYYY HH:mm` do backend e ISO do toque local).
 *
 * @param {Object} conversa
 * @returns {Number|null} Epoch em ms.
 */
export function instanteDeRecencia(conversa) {
  const bruto = conversa && (conversa.updated_at || conversa.created_at)
  // ⚠️ Nunca `parseDateSafe` aqui: o round-trip dele lê "12/09/2026 22:49"
  // como 9 de dezembro (ver `data-do-backend.js`) — era a ordem errada do print.
  return instanteDaDataDoBackend(bruto)
}

// Mais recente primeiro; sem data vai para o fim. Empate (o backend carimba
// em minutos) e sem-data preservam a ordem em que vieram — desempate por
// índice, para não depender da estabilidade do `sort` do engine.
function compararPorRecencia(a, b) {
  if (a.instante === b.instante) return a.indice - b.indice
  if (a.instante === null) return 1
  if (b.instante === null) return -1
  return b.instante - a.instante
}

/**
 * @param {Array} conversas Como vieram do servidor (qualquer ordem).
 * @returns {Array} Cópia, mais recente primeiro.
 */
export function ordenarPorRecencia(conversas) {
  return (conversas || [])
    .map((conversa, indice) => ({
      conversa,
      indice,
      instante: instanteDeRecencia(conversa),
    }))
    .sort(compararPorRecencia)
    .map((item) => item.conversa)
}
